package com.xtream.composeapp.presentation.ui.player


import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.LifecycleStartEffect
import com.xtream.composeapp.LocalSnackbarHostState
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import com.xtream.ui.platform.adaptiveValue
import com.xtream.video_player.BaseComposeMedia3Player
import kotlinx.serialization.json.Json
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun VodVideoPlayer(
    streamId: Int?,
    categoryId: Int?,
    modifier: Modifier = Modifier,
    title: String?=null,
    userInfViewModel: UserViewModel = koinViewModel(),
    appSettingsViewModel: AppSettingsViewModel = koinViewModel(),
    backdropUrl:String?=null,
    infos: List<String>? = null,
    onPlaybackLoadingChange: (Long, Long) -> Unit = {_,_->},
    progress: Long = 0L,
    progressUpdater: suspend () -> Long = { 0L },
    navKey: Screen,
    url: String?=null,
    onNavigationIconClick: () -> Unit,
    subtitles: List<MovieSubtitle.Subtitle?>? = null,

    onEnded: (()->Unit)? = null
) {




    val uri by remember {
        derivedStateOf {
            url ?:  ""
        }
    }
     val snackbarHostState = LocalSnackbarHostState.current



    val scope = rememberCoroutineScope()
    var savedProgress by remember { mutableStateOf(0L)}
    LaunchedEffect(streamId) {
        savedProgress = progressUpdater()

    }

    BaseComposeMedia3Player(
        url = uri,
        modifier =
            Modifier
                .fillMaxSize(),
        title = title,
        onPlaybackLoadingChange = onPlaybackLoadingChange,

        onPlaybackEnded = {
            onEnded?.invoke()
        },
        onScreenResizeClicked = {

                /*TODO scope.launch {
                    val updatedScale = activity.updateVideoScalingMode()
                    snackbarHostState.currentSnackbarData?.dismiss()
                    snackbarHostState.showSnackbar(
                        message = updatedScale,

                        )

                }*/

        },
        infos = infos,
        progress = savedProgress,

        subtitles = subtitles,

        onNavigationIconClick = onNavigationIconClick
    )


    LifecycleStartEffect(Unit) {
        appSettingsViewModel.setLastPlayedScreen(navKey::class.simpleName)

        with (appSettingsViewModel) {
            setLastPlayedScreen(navKey::class.simpleName)
            val category =Json.encodeToString(
                VodCategory(
                    categoryId = categoryId ?: -1,
                    categoryName = "",
                    parentId = null,
                )
            )
            setLastPlayedCategory(
                category
            )
            val ext = uri.toString()
                .substringAfterLast('.', "")
                .substringBefore('?')

             val stream = Json.encodeToString(
                VodStream(
                    streamId = streamId ?: -1,
                    name = title ?: "",
                    categoryId = categoryId ?: -1,
                    containerExtension = ext ?: ""
                )
            )
            setLastPlayedStream(stream)

        }

        onStopOrDispose {

        }
    }



    val shouldPortraitOnDispose = adaptiveValue( default = false, compactValue = true, expandedValue = false)
    DisposableEffect(Unit) {
        onDispose {
           // TODO if (shouldPortraitOnDispose)
            //activity.requestedOrientation = ActivityInfo.SCREEN_ORIENTATION_PORTRAIT

            with (appSettingsViewModel) {
                setLastPlayedScreen(null)
                setLastPlayedCategory(null)
                setLastPlayedStream(null)
            }
        }
    }
}



